import { h, Component } from 'preact';
import cx from 'classnames';
import { toDecimal } from '../../../../core/decimal';

interface InputProps {
  disabled?: boolean;
  onValueChange: Function;
  fieldName: string;
  isInvalid?: boolean;

  extraClasses?: string; // use string over string[]

  placeholder?: string;
  value?: any;
}

interface InputState {
  value?: any;
  errMessage?: string;
  // displayValue?: string;
  // isEditing?: boolean;
}

export class DiscountInput extends Component<InputProps, InputState> {
  constructor(props) {
    super(props);

    if (props.value) {
      this.setState({
        value: this.formatToCommaNotation(props.value),
        errMessage: ""
      });
    }
  }

  formatToCommaNotation(value): string {
    let trimmed = Number.parseFloat(value).toFixed(2);
    let formatted = toDecimal(Number.parseFloat(trimmed));
    return formatted;
  }

  onChange = (e) => {
    const targetValue = e.target.value;

    this.setState({
      value: targetValue
    })
  }

  onFocus = (e) => {
    const val = this.state.value;
    this.setState({
      value: this.convertStringToFloat(val)
    })
  }

  onBlur = (e) => {
    const actual_value = this.state.value.toString();
    this.validateInput(actual_value);
  }

  convertStringToFloat(str: string) {
    if (!str) return;

    const compressed = str.split(',').join("");
    return parseFloat(compressed);
  }

  validateInput(input: string) {
    const trimmed = input.replace(',', "").trim();

    if (trimmed === "") {
      this.setState({
        errMessage: "",
        value: ""
      })
      this.props.onValueChange("");
    } else if (isNaN(Number(trimmed))) {
      this.setState({
        errMessage: "Enter a number",
        value: trimmed
      })
    } else {
      const final = this.formatToCommaNotation(trimmed);
      this.setState({
        errMessage: "",
        value: final
      })
      this.props.onValueChange(parseFloat(trimmed));
    }
  }

  render(props: InputProps, state: InputState) {
    let errMessage = this.state.errMessage;

    return(
      <div>
        <div className="hi-currency-input input-group">
          <div className="input-group-prepend">
            <span
              id="peso-addon"
              className='input-group-text bg-white'
              >₱</span>
          </div>
          <input
            disabled={props.disabled}
            className="form-control border-left-0"
            type="text"
            autocomplete="off"
            placeholder={props.placeholder}
            value={ this.state.value }
            onChange={ this.onChange }
            onBlur={ this.onBlur }
            onFocus={ this.onFocus }
            />
        </div>
        { errMessage && <p className="text-danger"> { errMessage } </p> }
      </div>
    );
  }
}